import type { SankeyChartTooltipProps } from '../types/sankey-internal.js';

export const Tooltip = (props: SankeyChartTooltipProps) => null;

Tooltip['displayName'] = 'SankeyChart.Tooltip';
